import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { PlayerBar } from "./PlayerBar";
import { DispatchPopup } from "../DispatchPopup";

export function AppLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main className="flex-1 pt-[118px] md:pt-16 lg:pt-28">
        <Outlet />
      </main>
      <Footer />
      <PlayerBar />
      <DispatchPopup />
    </div>
  );
}
